import axios from 'axios'
import {config} from '@/api/config.js'
// https://github.com/axios/axios axios地址
// 添加新的baseUrl再创建一个实例

export const wechatArticleService = axios.create({
  baseURL: config.launcherService + `/rjhy-news/api/1/`,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const wechatCircleService = axios.create({
  baseURL: config.launcherService + '/rjhy-circle/api/1/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const wechatLauncherPlatformService = axios.create({
  baseURL: config.launcherService + '/rjhy-wechat-platform/',
  timeout: 30000,
  headers: {
  }
})
export const wechatLauncherPlatformService1 = axios.create({
  baseURL: config.launcherService1 + '/rjhy-wechat-platform/',
  timeout: 30000,
  headers: {
  }
})
export const wechatLauncherDynamicService = axios.create({
  baseURL: config.launcherService + '/rjhy-dynamic/api/1/',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})
export const wechatLauncherUserService = axios.create({
  baseURL: config.launcherService + '/rjhy-user',
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

export const rjhyUser = axios.create({
  baseURL: config.launcherService + '/rjhy-user/api/1/user/wechat/info',
  timeout: 30000,
  headers: {}
})

export const wechatFinderService = axios.create({
  baseURL: config.wechatFinderService,
  timeout: 30000,
  headers: {}
})

export const wechatUserService = axios.create({
  baseURL: config.launcherService + '/rjhy-wechat-platform/api/platform/user/info',
  timeout: 30000,
  headers: {}
})

export const wechatTeacherService = axios.create({
  baseURL: config.launcherService,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded'
  }
})

// /rjhy-promotion-wechat/
export const wechatPromotionService = axios.create({
  baseURL: config.yintechService + '/rjhy-promotion-wechat',
  timeout: 30000,
})